import { render, staticRenderFns } from "./FormDatepickerInternationalization.vue?vue&type=template&id=16b1d2bc&"
import script from "./FormDatepickerInternationalization.vue?vue&type=script&lang=js&"
export * from "./FormDatepickerInternationalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports